import http from './http';

export const login = (params) => {
  return http.post('/users/login', params).then((res) => {
    if (res.ok) {
      return res.json();
    }
    return Promise.reject({ text: res.statusText, code: res.status });
  });
};

export const getUser = () => {
  return http.get('/users').then((res) => {
    if (res.ok) {
      return res.json();
    }
    return Promise.reject({ text: res.statusText, code: res.status });
  });
};
